import constate from 'constate';
import { merge } from 'lodash-es';
import { useState } from 'react';
import { ENV } from '@/infrastructure/env-config';
import { AppConfig } from './types';

const currentDir = ENV.currentAppVersion;
// const globReg = new RegExp(`${currentDir}/[^/]+/([^.]+).[ts|tsx]$/`);
// @ts-ignore multi目录下的ts会被全部扫描当成配置内容
const configs = import.meta.webpackContext('./multi/', {  regExp: /.ts(x)?$/ });

let allConfigs: any = {};

configs.keys().forEach(async (item: string) => {
  const module: any = configs(item);
  const dirPrefix = `./${currentDir}`;
  if (item.startsWith(dirPrefix)) {
    allConfigs = merge(allConfigs, module.default);
  }
});

export enum MultiApp {
  // oa版本
  WOA = 'woa',
  // 子公司版本
  Internal = 'internal',
  // 商业化国内版
  Pro = 'pro',
  // 商业化海外版（新加坡）
  Sgp = 'sgp',
  // 商业化海外版（欧洲）
  Eu = 'eu',
  // 大疆独立部署版
  Dji = 'dji'
}

export interface BuglyAppContext {
  currentApp: MultiApp;
}

export interface UseAppProps {
  app: MultiApp
}

function useConfig(props: UseAppProps): AppConfig {
  const [currentApp, setCurrentApp] = useState(props.app);


  return {
    ...allConfigs,
    currentApp,
    setCurrentApp,
  };
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const [AppConfigProvider, useAppConfig] = constate(useConfig);

export {
  AppConfigProvider,
  useAppConfig,
  allConfigs as appConfig,
};
